const e = {
  overline: "0.625rem",
  // 10px
  caption: "0.75rem",
  // 12px
  small: "0.875rem",
  // 14px
  medium: "1rem",
  // 16px
  large: "1.125rem",
  // 18px
  h6: "1.25rem",
  // 20px
  h5: "1.5rem",
  // 24px
  h4: "1.75rem",
  // 28px
  h3: "2rem",
  // 32px
  h2: "2.25rem",
  // 36px
  h1: "2.5rem"
  // 40px
};
export {
  e as default
};
